import React from 'react'
import { connect } from "react-redux"
import { withRouter } from 'react-router'

import * as types from '../../constants/ActionTypes';
import backgroundImg from '../../images/background.jpg'

import { setTitle } from "../../actions/index"
import { setPractice } from '../../actions/therapist'

@connect((store) => {
    return { User: store.User.User, app: store.app, patients: store.patients }
})
class TherapistDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
        this.showPracticeChoices = this.showPracticeChoices.bind(this)
        this.practices = this.practices.bind(this);
        this.selectPractice = this.selectPractice.bind(this)
    }

    shouldComponentUpdate(nextState) {
        if (nextState.User !== undefined && nextState.User.therapistPractices === this.props.User.therapistPractices) {
            return false;
        }
        return true;
    }

    componentWillMount() {
        this.props.dispatch(setTitle('Therapist'))
        this.props.dispatch(setPractice({}));
        if (this.practices().length === 1) {
            this.selectPractice(this.practices()[0])
        }
    }

    selectPractice(practice) {
        const { router } = this.props;
        if (!practice) return
        this.props.dispatch(setPractice(practice));
        this.props.dispatch({ type: types.SET_PATIENTS, payload: [] })
        if (practice._id) {
            // console.log('Redirect to practice.');
            let encodePracticeName = encodeURIComponent(practice.name);
            let url = `/therapists/practice/${practice._id}/${encodePracticeName}`;
            // console.log('Redirect Url:', url);
            router.replace(url);
        }
    }

    practices() {
        return this.props.User.therapistPractices || []
    }

    showPracticeChoices() {
        let practices = this.practices();
        if (practices.length) {

            return (<div className="grid video-grid therapistDashboard">
                {
                    practices.map((practice, i) => {

                        const style = {
                            'height': '104px',
                            'backgroundPosition': 'center',
                            //'backgroundColor': '#ECEFF1',
                            'backgroundSize': 'cover',
                            'justifyContent': 'flex-start',
                            'minHeight': '120px',
                            'backgroundColor': 'rgba(0,0,0,0.2)',
                            'backgroundBlendMode': 'multiply',
                            'backgroundImage': practice.backgroundImg
                                ? `url(${practice.backgroundImg.scaled})`
                                : `url(${backgroundImg})`
                        }
                        return (<div onClick={() => {
                            this.selectPractice(practice)
                        }} key={practice._id}>
                            <div className="card link" style={style}>
                                <div className="card-content sub-title-bar-content row">
                                    {
                                        practice.logo
                                            ? <img width="72" alt="Logo" className="logo" src={practice.logo.thumb} />
                                            : null
                                    }
                                    <h5 className="padding">{practice.name}</h5>
                                </div>
                            </div>
                        </div>)
                    })
                }
            </div>)
        }
    }

    render() {
        return (<main className="main">
            {this.showPracticeChoices()}
        </main>)
    }
}

export default withRouter(TherapistDashboard);



// WEBPACK FOOTER //
// ./src/components/therapist/TherapistDashboard.jsx